import axios from "axios";
import React from "react";
import { connect } from "react-redux";
import { SignOutPage, Logo } from "./style.js";
import { userOperations } from "../../redux/user";
import logo from "../../assets/img/logo/logo-stacked.png";
import { Dimmer, Loader } from "semantic-ui-react";
import parse from "url-parse";
import _ from "lodash";

class SignOut extends React.Component {
  constructor(props) {
    super(props);
    let checkedIsNewAccount = false;
  }

  render() {
    return (
      <div>
        <SignOutPage>
          <Logo>
            <img src={logo} alt="Safe and Reliable Care" />
          </Logo>
          <h1>Summary Reports</h1>
          <p class="subtitle">You have been signed out of the reports.</p>
          <p class="more">You can safely close this window.</p>
        </SignOutPage>
      </div>
    );
  }
}

export default connect(store => {
  return {
    isLoggedIn: store.user.isLoggedIn,
    lastLoginFailed: store.user.lastLoginFailed,
    user: store.user,
  };
})(SignOut);



// WEBPACK FOOTER //
// ./src/pages/SignOut/index.jsx